import { CHANNEL_NAME_BY_CHANNEL_ID } from 'core/constants/general.constants';
import type { IGetBranchCustomersExclusionParams } from 'core/model/interfaces/distributors/branches.interface';
import { apiService } from 'core/services';
import type { TSliceExtraReducer } from 'core/store/store';
import { createAppAsyncThunk } from 'core/store/store.helpers';
import { notificationService } from 'shared/utils/notification.utils';
import { initialState, SLICE_NAMESPACE } from '../../constants';
import type { IDistributorsState } from '../../types';

export const fetchBranchCustomersExclusion = createAppAsyncThunk(
  `${SLICE_NAMESPACE}/fetchBranchCustomersExclusion`,
  async (params: IGetBranchCustomersExclusionParams) => {
    const { channel } = params;

    try {
      const response = await apiService.branches.getBranchCustomersExclusion(params);

      return response;
    } catch (error) {
      notificationService.global.error(
        `Falló al obtener los clientes excluidos de ${CHANNEL_NAME_BY_CHANNEL_ID[channel]}.`,
      );

      throw error;
    }
  },
);

export const fetchBranchCustomerExclusionReducer: TSliceExtraReducer<IDistributorsState> = builder =>
  builder
    .addCase(fetchBranchCustomersExclusion.pending, state => {
      state.branchesList.customersExclusion.loading = true;
      state.branchesList.customersExclusion.success = false;
      state.branchesList.customersExclusion.result = { ...initialState.branchesList.customersExclusion.result };
    })
    .addCase(fetchBranchCustomersExclusion.rejected, state => {
      state.branchesList.customersExclusion.loading = false;
      state.branchesList.customersExclusion.success = false;
      state.branchesList.customersExclusion.result = { ...initialState.branchesList.customersExclusion.result };
    })
    .addCase(fetchBranchCustomersExclusion.fulfilled, (state, action) => {
      state.branchesList.customersExclusion.loading = false;
      state.branchesList.customersExclusion.success = true;
      state.branchesList.customersExclusion.result = action.payload;
    });
